<template>
  <b-form-checkbox :checked="value" switch disabled> </b-form-checkbox>
</template>

<script>
export default {
  name: "PermissionStatusLabel",
  props: ["value"],
  methods: {},
};
</script>

<style></style>
